import React from 'react'
import { useParams } from 'react-router-dom'
import styles from './StateHeader.module.scss'
import Content from '../../../components/Content'
import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from '../dataDisplayOptions'
import { startDate, endDate, displayDate } from '../dates'
import Header from './Header'
import MiddleCharts from './../MiddleChart'
import GenderAgeView from '../Charts/GenderAgeView'

import TrendChart from './TrendChart'

const AllergiesStateDashboard = () => {
  const { area, loc } = useParams()
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              locationName={"US"}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'state'}
            >
              <Header headerType={area} headerNumber={2} geo_id={loc} />
             
              <DashboardMap
                geo_type={area}
                geo_parent={loc}
                zoomLocation={loc}
              />
              <div className={styles.mainDiv}>
              <TrendChart geo_type={area} geo_id={loc} data_type="ALLERGIES" />
              </div>
              <MiddleCharts geo_type={area} geo_id={loc} data_type="ALLERGIES" />
              {/* <AirQuality/> */}
              <GenderAgeView 
              data_type="ALLERGIES" 
              geo_type={area}
              geo_id={loc}
              />

            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default AllergiesStateDashboard
